import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { ToastItem, ToastService } from '../../core/services/toast.service';

@Component({
  selector: 'dmp-toast',
  imports: [AsyncPipe],
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastComponent {
  readonly toasts$ = this.toastService.toasts$;

  constructor(private readonly toastService: ToastService) {}

  dismiss(id: string): void {
    this.toastService.dismiss(id);
  }

  trackById(_index: number, toast: ToastItem): string {
    return toast.id;
  }

  ariaLive(severity: ToastItem['severity']): 'assertive' | 'polite' {
    return severity === 'error' ? 'assertive' : 'polite';
  }

  role(severity: ToastItem['severity']): 'alert' | 'status' {
    return severity === 'error' ? 'alert' : 'status';
  }
}
